import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { selectLocale } from 'models/localization';
import {
  DEFAULT_THEME_COLOR,
} from 'appenv';
import Routes from 'Routes';
import XtraBreadcrumbs from 'components/XtraBreadcrumbs';
import {
  ParticipantChoicesFilter,
} from './ParticipantFilterComponents';

const HallFilterContainer = styled.div<{isLoading: boolean}>`
  width: 300px;
  height: 100%;
  overflow: auto;
  padding: 24px;
  color: #282B40;
  background: rgba(255, 255, 255, 0.8);
  opacity: ${({ isLoading }) => (isLoading ? 0.5 : 1)};

  @media only screen and (max-width: 959px) {
    display: none;
  }
`;

const FilterTitleContainer = styled.div`
  width: 100%;
`;

const FilterText = styled.span`
  font-weight: bold;
  font-size: 18px;
  line-height: 18px;
  padding: 12px 0;
  display: inline-block;
  text-transform: uppercase;
`;

const ClearAllText = styled.span<{ color: string }>`
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.4px;
  cursor: pointer;
  transition: all 0.1s;
  display: block;
  padding: 12px 0;
  float: right;

  &:hover {
    color: ${({ color }: { color: string }) => color};
  }
`;

const FilterWrapper = styled.div`
  display: block;
`;

const StyledXtraBreadcrumbs = styled(XtraBreadcrumbs)`
  padding: 0;
`;

const ParticipantFilter = ({
  questions,
  onChoiceSelect,
  resetSelectedChoices,
  handleQuestionOpen,
  isLoading,
}: any) => {
  const { t } = useTranslation();
  const { themeColor } = useSelector((s: any) => s.eventConfigs);

  const locale = useSelector(selectLocale);
  const { pageNames: { lobby, participant } } = useSelector((s: any) => s.eventConfigs);

  const lobbyName = lobby?.[locale] || t('page.lobby', 'Lobby');
  const participantName = participant?.[locale] || t('page.participant', 'Participants');

  return (
    <HallFilterContainer isLoading={isLoading}>
      <StyledXtraBreadcrumbs paths={[{ name: lobbyName, to: Routes.lobby }, { name: participantName }]} />
      <FilterTitleContainer>
        <FilterText>
          {t('filter.title', 'Filter')}
        </FilterText>
        <ClearAllText onClick={resetSelectedChoices} color={themeColor || DEFAULT_THEME_COLOR}>
          {t('filter.clear_all', 'Clear all')}
        </ClearAllText>
      </FilterTitleContainer>
      <FilterWrapper>
        <ParticipantChoicesFilter
          questions={questions}
          onChoiceSelect={onChoiceSelect}
          isRootQuestion
          handleQuestionOpen={handleQuestionOpen}
          isLoading={isLoading}
          isDesktop
        />
      </FilterWrapper>
    </HallFilterContainer>
  );
};

export default ParticipantFilter;
